<template>
  <v-layout
    pt-5
    mt-4
    pb-3
    justify-center
  >
   <v-flex 
    xs6
    mt-3>
   <v-img
      :src="src"
      />
      </v-flex>
    <v-flex
      xs6
    >
      <panel title="Register">
        <form
          name="register-form"
          autocomplete="off"
        >
          <v-text-field
            v-model="email"
            label="Email associated with your account"
          />
          <br>
          <v-text-field
            v-model="password"
            label="Password"
            type="password"
            autocomplete="new-password"
          />
          <v-text-field
            v-model="password2"
            label="Password"
            type="password"
            autocomplete="new-password"
          />
        </form>
        <br>
        <p class="headline text-xs-left"><b> Copyright Notice</b>
        </p>
        <p class="body-1 text-xs-left">
          The Reiss Motivation Profile® (“RMP”) and the RMP Testing Program are
          protected by copyright as to test content and related materials (e.g.,
          examiner and technical manual), and as a collective work and/or
          compilation, pursuant to United States (“US”) copyright laws, international
          conventions, and other foreign national copyright laws. The RMP and the
          RMP Testing Program also are protected by US trade secret laws. Further,
          IDS product names and logos are protected under US and international
          trademark laws.
        </p>
        <p class="body-2 text-xs-left">
          A user may not copy, memorize for sharing, distribute, publicly display,
          modify, transmit, reuse, repost, or use for public or commercial purposes,
          any of the contents of the Reiss Motivation Profile® or the RMP Testing
          Program without the express written permission of IDS, obtained in writing
          in advance of such use. Permission requests should be sent to:
          <a href="mailto:ids@idspublishing.com">ids@idspublishing.com.</a> A user may not alter or remove this Copyright
          Notice from any RMP or other IDS materials.
        </p>
        <p class="body-2 text-xs-left">
          By clicking the ‘Submit Registration’ button, I indicate I have read the above
          Copyright Notice and hereby acknowledge I agree to be bound by those
          terms and conditions.
        </p>
        <div
          class="danger-alert"
          v-html="error"
        />
    <v-dialog 
    v-model="dialog" 
    persistent
    max-width="800">
    <!-- max-width="640"> -->
      <template 
      v-slot:activator="{ on }">
        <v-btn 
        color="primary" 
        dark 
        v-on="on">Submit Registration</v-btn>
      </template>
      <v-card>
        <!-- <v-card-title  -->
        <!-- class="headline align-center">Cookie Policy for the Reiss Motivation Profile® </v-card-title> -->
<v-card-text class ="text-xs-justify">
<p class="headline text-center">Cookie Policy for the Reiss Motivation Profile® </p>
<div class="copyright-body">
<p class= "text-center">This is the Cookie Policy for the Reiss Motivation Profile®, which is accessible from <a href="http://www.rmpdashboard.com">www.rmpdashboard.com</a></p>
<p class="text-left"><b>What Are Cookies</b></p>
<p class="text-left">As is common practice with almost all professional websites, this site uses cookies - tiny files that are downloaded to your computer to improve your experience. 
  This page describes what information the cookies gather, how we use the information, and why we sometimes need to store these cookies. 
  We also share how you can prevent these cookies from being stored. Please note, however, that preventing the cookies from being stored 
  may downgrade or 'break' certain elements of the site’s functionality. For this reason, we recommend you allow all cookies to remain on, 
  in case they are needed to provide a feature that you use on this site.</p>
<br>
<p class="text-left"><b>The Cookies We Set</b></p>
<ul>
<li class="text-left"><b>Account related cookies:</b>  If you create an account with us, we will use cookies for the management of the registration process and for general administration. These cookies usually are deleted when you log out of the site. In some cases, 
though, the cookies may remain to remember your site preferences.</li>
<br>
<li class="text-left"><b>Log in related cookies:</b>  We use cookies when you are logged in so that we can remember this fact. This prevents your having to log in every time you visit a new page. These cookies typically are deleted when you log out of the site to ensure
that you can access restricted features and areas only when you are logged in.</li>
<br>
<li class="text-left"><b>Forms related cookies:</b>  When you submit data through a form such as that found on contact pages, cookies may be set to remember your user details for future correspondence.</li>
<br>
<li class="text-left"><b>Site preferences cookies:</b> To enhance your experience on this site, we provide the functionality to set your preferences for how the site runs when you use it. To do this, we set cookies so this information can retrieved whenever you interact 
with a page that is affected by your preferences.</li>
</ul>	
<br>
<br>
<p class="text-left"><b>Disabling Cookies</b></p>
<p class="text-left">You can prevent the setting of cookies on this site by adjusting the settings on your browser. See “Help” on your browser for how to do this. 
  Be aware that disabling cookies will affect the functionality of this website as well as many other websites that you 
visit. If you want to be able to access and use all of the features of this site, we recommended that you do not disable cookies.</p>
<br>
<p class="text-left"><b>More Information</b></p>
<p class="text-left">If you have questions or need more information, please email us at <a href="mailto:ids@idspublishing.com">ids@idspublishing.com.</a></p>
</div>

</v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn 
          :color="strongColor" 
          dark 
          @click="dialog = false">Disagree</v-btn>
          <v-btn 
          :color="strongColor" 
          dark 
          @click="register">Agree</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        
        <v-btn
          v-if="password === password2 & password !== '' && agree"
          :color="strongColor"
          dark
          @click="register"
        >
          Register
        </v-btn>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'
import rmp_tagline from '@/assets/rmp_tagline.png'
import {
  STRONG_COLOR,
  BUSINESS
} from "@/components/globals/consts"

export default {
	data () {
		return {
      agree: false,
			email: '',
			password: '',
      password2: '',
      src: rmp_tagline,
      error: null,
      dialog: false,
      strongColor: STRONG_COLOR,
      testType: BUSINESS
		}
	},
	methods: {
		async register () {
			try {
        if (this.password !== this.password2) {
          this.error = 'Passwords must be the same'
          this.dialog = false
        }  else if (this.password2 === this.password) {

          const response = await AuthenticationService.register({
            email: this.email.trim().toLowerCase(),
            password: this.password
          })
          
          await this.$store.dispatch('setToken', response.data.token)
          await this.$store.dispatch('setUser', response.data.user)
          await this.$store.dispatch('setTestType', this.testType)
          
          this.$router.push({
            name: 'clients'
          })
        }
      }
       catch (error) {
        
        if (error) {
        console.log(error) 
        this.error = error.response.data.error 
        this.dialog = false
        }
			}
		}
	}
}
</script>

<style scoped>
.copyright-body {
  color: black;
  font-size: 14px

}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue